import { render } from "./EmployeeDocumentsUpload.vue?vue&type=template&id=71f5d250&scoped=true"
import script from "./EmployeeDocumentsUpload.vue?vue&type=script&lang=js"
export * from "./EmployeeDocumentsUpload.vue?vue&type=script&lang=js"

import "./EmployeeDocumentsUpload.vue?vue&type=style&index=0&id=71f5d250&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f5d250"]])

export default __exports__